  import {
    gsap,
  } from 'gsap/all';

  export default class {
    constructor() {
      let that = this;

      this.modals = document.querySelector(".trainer-modals");
      this.trainerCards = document.querySelectorAll(".ifit-trainers-tabs__content-trainer");
      this.closeButtons = document.querySelectorAll(".trainer-modals__close");



      // this.tabOptionsContainer = document.querySelector(".ifit-trainers-tabs__options-container");
      // this.spaceFromWindow = document.querySelector(".ifit-trainers-tabs__options").getBoundingClientRect().x;
      // this.tabOptions = document.querySelectorAll(".ifit-trainers-tabs__option");
      // this.activeTabOption = document.querySelector(".ifit-trainers-tabs__option.active");
      // this.tabContents = document.querySelectorAll(".ifit-trainers-tabs__content");
      // this.activeTabContent = document.querySelector(".ifit-trainers-tabs__content.active");

      this.trainerCards.forEach(card => {
        card.addEventListener('click', event => {
          document.body.classList.add('hide-overflow');
          //add modals open class
          this.modals.classList.add('open');

          //add modal active class
          document.querySelector(card.dataset.trainerId).classList.add('active')
        });
      });

      this.closeButtons.forEach(closeBtn => {
        closeBtn.addEventListener('click', event => {
          document.body.classList.remove('hide-overflow');
          //add modals open class
          this.modals.classList.remove('open');

          //add modal active class
          document.querySelector('.trainer-modals__item.active').classList.remove('active')
        });
      });

    }

  }
